import { fetchAccounts } from '../api';
import { QueryKeys, useCustomQuery } from '@queries/index';

export type AccountOption = {
  label: string,
  value: string,
}

export const useAccountsOptions = () =>
  useCustomQuery<AccountOption[]>(
    [QueryKeys.accounts.AccountsList],
    {
      customFetch: fetchAccounts,
    }
  );
